import { serviceActions } from 'state/modules/service';
import { AlertType } from '../../../graphql/schema/p4types';

export default function hasValidationErrors(props) {
  const { validationErrors, dispatch } = props;
  if (validationErrors) {
    dispatch(serviceActions.genericAlert('Warning', `Please correct the highlighted errors`, AlertType.Warning));
    return true;
  }
  return false;
}
